import { render, staticRenderFns } from "./producer_submit_select_tastingproducts.vue?vue&type=template&id=ac2a4814&scoped=true"
import script from "./producer_submit_select_tastingproducts.vue?vue&type=script&lang=js"
export * from "./producer_submit_select_tastingproducts.vue?vue&type=script&lang=js"
import style0 from "./producer_submit_select_tastingproducts.vue?vue&type=style&index=0&id=ac2a4814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2a4814",
  null
  
)

export default component.exports